<template lang="pug">
.cp-team-process
  .title 团队历程
  img(src="../../../assets/timeline.jpg")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-team-process
  margin-bottom 103px
  text-align center
  img
    width 1920px
    @media screen and (max-width: 1920px) {
      width 80%
    }

</style>
